import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var GrantSlackAccessCommandClass;
function GrantSlackAccessCommand() {
  if (GrantSlackAccessCommandClass === VOID) {
    class $ {
      constructor(code, state) {
        this.b2j_1 = code;
        this.c2j_1 = state;
      }
      toString() {
        return 'GrantSlackAccessCommand(code=' + this.b2j_1 + ', state=' + this.c2j_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.b2j_1);
        result = imul(result, 31) + getStringHashCode(this.c2j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessCommand()))
          return false;
        if (!(this.b2j_1 === other.b2j_1))
          return false;
        if (!(this.c2j_1 === other.c2j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessCommand');
    GrantSlackAccessCommandClass = $;
  }
  return GrantSlackAccessCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatchervu4hb3oerxrm,
  GrantSlackAccessCommand as GrantSlackAccessCommand2t6ixclvq062w,
};
//endregion

//# sourceMappingURL=GrantSlackAccessCommand.mjs.map
